<template>
  <div id="ImportCodeManage" class="well" style="padding: 0 1em">
    <b-button variant="success" v-on:click="getSpecialClassInfo()"
      >專班代碼管理</b-button
    >
    <b-button variant="success" v-on:click="dataMode = 1"
      >專班代碼匯入</b-button
    >
    <b-tabs content-class="mt-3">
      <b-tab
        title="專班代碼管理"
        :active="dataMode == 0"
        :disabled="dataMode != 0"
      >
        <div
          class="dataTables_scrollBody"
          style="
            font-size: 14px;
            position: relative;
            overflow: auto;
            max-height: 100%;

            border-bottom: 1px solid #111;
            border-top: 1px solid #111;
          "
        >
          <b-table-simple
            class="ncut-table-menu-striped ncut-table-menu"
            fixed
            responsive
            bgcolor="#FFFFFF"
          >
            <b-thead class="ncut-thead-menu">
              <b-tr>
                <b-th style="width: 3em; min-width: 1em">序號</b-th>
                <b-th style="width: 3em; min-width: 1em">核准年度</b-th>
                <b-th style="width: 8em; min-width: 1em">專班編號</b-th>
                <b-th style="width: 8em; min-width: 1em">專班名稱</b-th>
                <b-th style="width: 3em; min-width: 3em">學校代碼</b-th>
                <b-th style="width: 3em; min-width: 2em">起始年度</b-th>
                <b-th style="width: 3em; min-width: 2em">迄止年度</b-th>
                <b-th style="width: 3em; min-width: 10em">系所編號</b-th>
                <b-th style="width: 30px; min-width: 5em">管理</b-th>
              </b-tr>
            </b-thead>
            <b-tbody class="ncut-tbody-menu">
              <b-tr
                v-for="(i, index) in filteredDocs"
                :key="i.sn"
                :index="i.sn"
                v-bind:style="{
                  background: selectedRowIndex == index ? headerColor : '',
                }"
                @click="selectedRowIndex = index"
              >
                <b-td style="text-align: left">
                  {{ i.sn }}
                </b-td>
                <b-td style="text-align: left">
                  {{ i.reviewYear }}
                </b-td>
                <b-td style="text-align: left">
                  {{ i.specialClassNumber }}
                </b-td>
                <b-td style="text-align: left">
                  {{ i.specialClassName }}
                </b-td>
                <b-td style="text-align: left">
                  {{ i.code }}
                </b-td>
                <b-td style="text-align: left">
                  {{ i.startYear }}
                </b-td>
                <b-td style="text-align: left">
                  {{ i.endYear }}
                </b-td>
                <b-td style="text-align: left">
                  {{ i.dptcd }}
                </b-td>

                <b-td style="text-align: left">
                  <button
                    href="#"
                    @click="remove(i.sn)"
                    class="btn btn-outline-success"
                    type="button"
                    style="font-size: 14px"
                  >
                    刪除
                  </button>
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
          <b-pagination
            v-model="currentPage"
            :total-rows="total"
            :per-page="pageSize"
            v-if="total > pageSize"
          />
        </div>
      </b-tab>
      <b-tab
        title="專班代碼匯入"
        :active="dataMode == 1"
        :disabled="dataMode != 1"
      >
        上傳編碼UTF-8 附檔.csv檔案格式如下(含欄位名稱):<a href="special.csv"
          >下載範例檔</a
        ><br />
        <table class="table" style="width: auto; align: left">
          <tbody>
            <tr>
              <td>核准年度</td>
              <td>專班編號</td>
              <td>專班名稱</td>
              <td>學校代碼</td>
              <td>起始年度</td>
              <td>迄止年度</td>
              <td>系所編號</td>
            </tr>

            <tr>
              <td>101</td>
              <td>101-01-02-07</td>
              <td>機電控制專班</td>
              <td>60043</td>
              <td>103</td>
              <td>106</td>
              <td>D123</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 1em" colspan="6">
                <b-form-file
                  class="mb-2"
                  ref="file-input"
                  :no-drop="true"
                  :no-traverse="true"
                  name="file"
                  v-model="file"
                  @input="fileChange(0)"
                  placeholder="上傳csv檔案"
                  accept=".csv"
                  enctype="multipart/form-data"
                ></b-form-file>

                <button
                  href="#"
                  @click.prevent="importCode()"
                  class="btn btn-outline-success"
                  type="button"
                  style="font-size: 14px"
                >
                  送出
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </b-tab>
    </b-tabs>
    <b-modal ref="q-modal" hide-footer title="請注意">
      <div class="d-block text-center">
        <h3>是否確認刪除此筆資料?</h3>
      </div>
      <b-button class="mt-3" variant="outline-danger" block @click="cancalRM"
        >取消刪除</b-button
      >
      <b-button class="mt-2" variant="outline-info" block @click="confirmRM"
        >刪除確認</b-button
      >
    </b-modal>
  </div>
</template>


<script>
import * as tools from "../tool";


export default {
  name: "ImportCodeManage",
  data() {
    return {
      sn: 0,
      total: 0,
      inputData: null,
      selectedRowIndex: 0,
      currentPage: 1,
      pageSize: 10,
      dataMode: 0,
      selectedFile: null,
      mode: 0,
      file: [],

    };
  },
  computed: {
    filteredDocs: function () {
      let data = [];
      if (this.inputData != null) {
        data = this.inputData.slice(
          (this.currentPage - 1) * this.pageSize,
          this.currentPage * this.pageSize
        );
      }
      return data;
    },

    headerColor() {
      return "#f7e8aa";
    },
  },
  methods: {
    fileChange(index) {
      this.formData = new FormData();

      if (index == 0) {
        this.formData.append("header", this.file);
      }
      var vm = this;
      this.$http
        .post("./WebApi/Common/UploadV3", vm.formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: function (progressEvent) {
            console.log(
              "Upload progress: " +
                Math.round((progressEvent.loaded / progressEvent.total) * 100) +
                "%"
            );
          },
        })
        .then(function (response) {

          console.log("ok");
        })
        .catch(function (error) {
          console.log(error);
          console.log(error.response);
        });
    },
    remove(sn) {
      this.sn = sn;
      this.$refs["q-modal"].show();
    },
    cancalRM() {
      this.$refs["q-modal"].hide();
    },

    confirmRM() {
      //刪除專班Code資料
      this.$refs["q-modal"].hide();
      var vm = this;
      this.$http
        .get(
          "./WebApi/EconomicDisadvantage/RemoveSpecialClassCode/".concat(vm.sn)
        )
        .then((response) => {
          if (response.data) {
            tools.showAlert(vm, "success", "恭喜您,刪除成功");
            vm.getSpecialClassInfo();
          } else {
            tools.showAlert(vm, "danger", "對不起,刪除失敗");
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, "danger", "網路連線失敗" + error);
        });
    },
    importCode() {
      var vm = this;
      if (vm.isEmpty(vm.file.name)) {
        alert("請上傳csv檔案");
        return;
      }
   ;
      this.$http
        .get("./WebApi/EconomicDisadvantage/ImportCode")
        .then((response) => {
          if (response.data != "") {
            console.log(response);
            //tools.showAlert(vm, "success", "匯入檔案成功" );
            alert("匯入檔案成功");
            vm.getSpecialClassInfo();
          } else {
            alert("匯入檔案失敗");
          }
        })
        .catch((error) => {
          // alert("匯入檔案失敗");
          console.log(error);
          tools.showAlert(vm, "danger", "匯入檔案失敗");
        });
    },



    close() {
      this.$emit("hideModal");
    },
    isEmpty(data) {
      return data != null && data != undefined && data.length > 0
        ? false
        : true;
    },

    getSpecialClassInfo() {
      this.dataMode = 0;
      let vm = this;
      vm.selected2 = vm.IsComplete;

      this.$http
        .get("./WebApi/EconomicDisadvantage/GetSpecialClassInfo/")
        .then((response) => {
          if (!tools.isNull(response.data)) {
            vm.inputData = response.data;
            vm.total = vm.inputData.length;
            vm.currentPage = 1;
          }
        })
        .catch(function (error) {
          alert("網路連線失敗" + error);
          // tools.showAlert(vm.inputData, "danger", "網路連線失敗" + error);
        });
    },
  },
  created() {
    console.log("======created ImportCodeManageView =====");
    this.getSpecialClassInfo();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
